import { render, staticRenderFns } from "./LiveLearn.vue?vue&type=template&id=35a10968&scoped=true"
import script from "./LiveLearn.vue?vue&type=script&lang=js"
export * from "./LiveLearn.vue?vue&type=script&lang=js"
import style0 from "./LiveLearn.vue?vue&type=style&index=0&id=35a10968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a10968",
  null
  
)

export default component.exports